import Icon from "@ant-design/icons";

const ShieldUserFillSvg = () => {
  return (
    <svg
      width="18"
      height="22"
      viewBox="0 0 18 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.783 1.826L9 0L17.217 1.826C17.4391 1.87536 17.6377 1.99897 17.78 2.1764C17.9224 2.35384 18 2.57452 18 2.802V12.789C17.9999 13.7767 17.756 14.7492 17.2899 15.62C16.8238 16.4908 16.1499 17.2331 15.328 17.781L9 22L2.672 17.781C1.85027 17.2332 1.17646 16.4911 0.710348 15.6205C0.244236 14.7498 0.000236356 13.7776 0 12.79V2.802C3.90378e-05 2.57452 0.0776379 2.35384 0.21999 2.1764C0.362341 1.99897 0.560937 1.87536 0.783 1.826ZM9 10C9.66304 10 10.2989 9.73661 10.7678 9.26777C11.2366 8.79893 11.5 8.16304 11.5 7.5C11.5 6.83696 11.2366 6.20107 10.7678 5.73223C10.2989 5.26339 9.66304 5 9 5C8.33696 5 7.70107 5.26339 7.23223 5.73223C6.76339 6.20107 6.5 6.83696 6.5 7.5C6.5 8.16304 6.76339 8.79893 7.23223 9.26777C7.70107 9.73661 8.33696 10 9 10ZM4.527 15H13.473C13.3518 13.8984 12.8283 12.8803 12.0029 12.1407C11.1775 11.4012 10.1082 10.9922 9 10.9922C7.89175 10.9922 6.82248 11.4012 5.99708 12.1407C5.17168 12.8803 4.64822 13.8984 4.527 15Z"
        fill="#5F9FAB"
      />
    </svg>
  );
};

export const ShieldUserFillIcon = (props) =>
  <Icon
    component={ShieldUserFillSvg}
    {...props}
  />;
